module.exports = __webpack_public_path__ + "img/slide9.030b1f9c.jpg";